import Glide from "@glidejs/glide";

const thingsCardSliderHandler = () => {
    const thingsSliders = document.querySelectorAll(".things-card-row__glide");

    thingsSliders.forEach((slider) => {
        if (!slider.hasAttribute("data-initialized")) {
            const glide = new Glide(slider, {
                type: "carousel",
                startAt: 0,
                gap: 35,
                perView: 2.5,
                breakpoints: {
                    1024: { perView: 2.2 },
                    768: { perView: 1.5, gap: 20,},
                },
            });

            let previousIndex = glide.index;
            let isDragging = false;
            let startX = 0;
            let currentX = 0;
            let bulletContainer;
            let totalSlides;

            const initDragBehavior = () => {
                bulletContainer = slider.querySelector('.things-card-row__glide-bullets');
                if (!bulletContainer) return;

                const bullets = slider.querySelectorAll('.glide__bullet-single');
                totalSlides = bullets.length;

                const handleDragStart = (e) => {
                    isDragging = true;
                    startX = e.type === 'mousedown' ? e.pageX : e.touches[0].pageX;
                    currentX = startX;
                    bulletContainer.style.transition = 'none';
                };

                const handleDragMove = (e) => {
                    if (!isDragging) return;
                    e.preventDefault();
                    
                    currentX = e.type === 'mousemove' ? e.pageX : e.touches[0].pageX;
                    const diff = currentX - startX;
                    
                    // Calculate slide change based on drag distance
                    if (Math.abs(diff) > 50) { // Threshold for slide change
                        isDragging = false;
                        // Reversed direction logic here
                        const direction = diff > 0 ? '>' : '<';
                        glide.go(direction);
                        startX = currentX;
                    }
                };

                const handleDragEnd = () => {
                    if (!isDragging) return;
                    isDragging = false;
                    bulletContainer.style.transition = '';
                };

                // Mouse Events
                bulletContainer.addEventListener('mousedown', handleDragStart);
                window.addEventListener('mousemove', handleDragMove);
                window.addEventListener('mouseup', handleDragEnd);

                // Touch Events
                bulletContainer.addEventListener('touchstart', handleDragStart, { passive: true });
                bulletContainer.addEventListener('touchmove', handleDragMove, { passive: false });
                bulletContainer.addEventListener('touchend', handleDragEnd);

                // Add cursor styles
                bulletContainer.style.cursor = 'grab';
                bulletContainer.addEventListener('mousedown', () => {
                    bulletContainer.style.cursor = 'grabbing';
                });
                window.addEventListener('mouseup', () => {
                    bulletContainer.style.cursor = 'grab';
                });
            };

            // Existing bullet animation logic
            glide.on('run', function() {
                const currentIndex = glide.index;
                const bullets = slider.querySelectorAll('.glide__bullet-single');

                let direction;
                if (previousIndex === bullets.length - 1 && currentIndex === 0) {
                    direction = 'forward';
                } else if (previousIndex === 0 && currentIndex === bullets.length - 1) {
                    direction = 'backward';
                } else if (currentIndex > previousIndex) {
                    direction = 'forward';
                } else {
                    direction = 'backward';
                }

                bullets.forEach(bullet => {
                    bullet.classList.remove('fade-out-forward', 'fade-out-backward', 'forward', 'backward');
                });

                bullets.forEach((bullet, index) => {
                    if (index === currentIndex) {
                        bullet.classList.add('glide__bullet--active', direction);
                    } else if (index === previousIndex) {
                        bullet.classList.add(`fade-out-${direction}`);
                        bullet.classList.remove('glide__bullet--active');
                    } else {
                        bullet.classList.remove('glide__bullet--active');
                    }
                });

                previousIndex = currentIndex;
            });

            glide.mount();
            initDragBehavior();
            slider.setAttribute("data-initialized", "true");
        }
    });
};

if (document.readyState !== "loading") {
    thingsCardSliderHandler();
} else {
    document.addEventListener("DOMContentLoaded", thingsCardSliderHandler);
}